module.exports = __webpack_public_path__ + "img/38.664f680b.webp";